module.exports = __webpack_public_path__ + "static/media/profile.6b584c23.jpeg";